import React, { useState, useEffect } from "react";
import { ElmentDetail } from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentPerformanceTabs/StudentDetailsTab";
import { Col, Row } from "reactstrap";
import { convertCamelCaseToTitle } from "utilFunctions/helperFunctions/utilFunctions";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
// import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
// import { ToastContextDispatch } from "Context/CommonContext";
// import { BASE_URL } from "utilFunctions/Constants/urlConstants";

const MyBatchDetailsTab = ({ screen, state, batchDetailsData }: any) => {
  const [batchDetailsTranformedData, setbatchDetailsData] = useState<any>(null);
  // const ToastDispatch = useContext(ToastContextDispatch);

  console.log("API DATA", state);
  console.log("api data from first screen", batchDetailsData);

  const mapData = (originalData: any) => {
    return {
      batchDetails: {
        batchType: originalData.batchType.toUpperCase(),
        classSection: originalData.classSection,
        classType: originalData.classType,
        board: originalData.schoolBoard,
        medium: originalData.medium,
        msTeamsSequence: originalData.msTeamsGroupSequence,
      },
      academicDetails: {
        academicCareer: originalData.academicCareer,
        academicGroup: originalData.academicGroup,
        courseId: originalData.courseId.toString(),
        academicYear: originalData.academicYear,
        academicPhase: originalData.academicPhase,
        batchClass: originalData.batchClass,
      },
      branchDetails: {
        region: originalData.region,
        businessArea: originalData.businessArea,
      },
    };
  };

  useEffect(() => {
    if (batchDetailsData != null) {
      console.log("checking batch data from first component", batchDetailsData);
      setbatchDetailsData(mapData(batchDetailsData));
    }
  }, []);

  // useEffect(() => {
  //   console.log(
  //     "CHECKING BATCH DATA FROM API In Main abcd in second use effect ",
  //     batchDetailsData
  //   );
  // }, [batchDetailsData]);

  console.log("checking api data before rendering", batchDetailsData);
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "batchDetailMainDiv p-3 mr-3"
          : "batchDetailMainDivMB"
      }
    >
      {batchDetailsTranformedData ? (
        Object.keys(batchDetailsTranformedData).map(
          (ele: any, index: number) => {
            return (
              <div key={index}>
                <div className="batchDetailMainHeading">
                  {convertCamelCaseToTitle(ele)}
                </div>
                <Row className="MyBatchesFacultyDetailTabRow mt-0 pt-0">
                  {Object.keys(batchDetailsTranformedData[ele]).map(
                    (el: any, index: number) => {
                      return (
                        <Col
                          xxl="4"
                          xl="4"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                          key={index}
                          className="batchDetailMainCol pl-0 mt-0"
                        >
                          <ElmentDetail
                            label={convertCamelCaseToTitle(el)}
                            value={
                              batchDetailsTranformedData[ele]?.[el] || "NA"
                            }
                          />
                        </Col>
                      );
                    }
                  )}
                </Row>
              </div>
            );
          }
        )
      ) : (
        <div className="mt-4 mb-8">
          <NoResultFoundSearch
            primaryMessage="Batch details information not available."
            secondaryMessage={
              "Issue with data sync between Phoenix and AakashGuru. Contact your EDP team for assistance."
            }
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      )}
    </div>
  );
};
export default MyBatchDetailsTab;
